/**
 * 加载高德 AMapUI（PathSimplifier / PathNavigator 依赖）
 */
export function loadAmapUIScript() {
  if (typeof window !== 'undefined' && window.AMapUI) {
    return Promise.resolve(window.AMapUI)
  }
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="webapi.amap.com/ui"]')
    if (existing) {
      const t = setInterval(() => {
        if (window.AMapUI) {
          clearInterval(t)
          resolve(window.AMapUI)
        }
      }, 50)
      setTimeout(() => {
        clearInterval(t)
        if (!window.AMapUI) reject(new Error('AMapUI 加载超时'))
      }, 20000)
      return
    }
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = 'https://webapi.amap.com/ui/1.1/main.js'
    s.onload = () => resolve(window.AMapUI)
    s.onerror = () => reject(new Error('AMapUI 脚本加载失败'))
    document.head.appendChild(s)
  })
}
